import { apiClient } from '@/services/ApiClient.js'

export default {
  getSettings() {
    return apiClient.get('config').then(response => {
      return response
    })
  },
  getSetting(settingId) {
    return apiClient
      .get('config/' + settingId)
      .then(response => {
        return response
      })
      .catch(err => {
        throw err
      })
  },
  toggleSetting(settingId, settingVal) {
    return apiClient
      .patch('config/' + settingId + '/set', {
        settingVal: settingVal
      })
      .then(response => {
        return response
      })
      .catch(err => {
        throw err
      })
  },
  createSetting(setting) {
    return apiClient
      .post('config', setting)
      .then(response => {
        return response
      })
      .catch(err => {
        throw err
      })
  },
  updateSetting(settingId, setting) {
    return apiClient
      .patch('config/' + settingId, setting)
      .then(response => {
        return response
      })
      .catch(err => {
        throw err
      })
  },
  deleteSetting(settingId) {
    return apiClient
      .delete('config/' + settingId)
      .then(response => {
        return response
      })
      .catch(err => {
        throw err
      })
  }
}
